<script setup lang="ts">
  import type { Ref } from 'vue';
  import { VueFinalModal } from 'vue-final-modal'

  defineProps<{
    title?: Ref<string>
  }>()

  const emit = defineEmits<{
    (e: 'confirm'): void
  }>()

</script>


<template>
  <VueFinalModal
    class="confirm-modal"
    content-class="confirm-modal-content"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
    :show-swipe-banner="false"
  >
    <h1>{{ title }}</h1>
    <slot />
    <button @click="emit('confirm')">
      OK
    </button>
  </VueFinalModal>
</template>

<style>
.confirm-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-modal-content {
  display: flex;
  flex-direction: column;
  padding: 1rem;
  background: #24314F;
  border-radius: 0.5rem;
  border: 2px solid #486099;

}

.confirm-modal-content > * + *{
  margin: 0.5rem 0;
}

.confirm-modal-content h1 {
  font-size: 1.375rem;
}

.confirm-modal-content button {
  margin: 0.25rem 0 0 auto;
  padding: 0 8px;
  border: 1px solid;
  border-radius: 0.5rem;
}

</style>
